import React, { useEffect, useState } from "react";
import { Modal, Form, Container, Col, Row } from "react-bootstrap";
import { useGetAllTransactionsQuery } from "../../store";
import {
    CustomTable,
    DeleteButton,
    LoadingBox,
    MessageBox,
    MotionDiv,
    useTitle,
    ViewButton,
} from "../../components";
import { useNavigate } from "react-router-dom";
import { ImCross } from "react-icons/im";
import { FaCheck, FaUserPlus, FaUserTimes } from "react-icons/fa";
import { Button } from "react-bootstrap";
import { ChatButton } from "../../components/layout/CustomTable";
import { DateInput, SelectInput } from "../../components/layout/CustomForm";
import { toast, ToastContainer } from "react-toastify";
import { toastOptions } from "../../utils/error";

const column = [
    "Sr No.",
    "File No.",
    "Payment Status",
    "Lender",
    "Price",
    "Payment Date",
    "Actions",
];

const TransactionManagement = () => {
    useTitle("Transactions");

    const [currentPage, setCurrentPage] = useState(1);
    const [resultPerPage, setResultPerPage] = useState(10);
    const [transactions, setTransactions] = useState([]);
    const navigate = useNavigate();
    const [filters, setFilters] = useState({
        status: "",
        from: "",
        to: "",
    });

    const formatDateTime = (dateTimeString) => {
        const dateTime = new Date(dateTimeString);
        const month = dateTime.toLocaleString("default", { month: "short" });
        const day = dateTime.getDate();
        const year = dateTime.getFullYear();
        const time = dateTime.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "numeric",
            hour12: true,
        });
        return `${day} ${month}, ${year} ${time}`;
    };

    const { isLoading, isFetching, isError, data, error, refetch } =
        useGetAllTransactionsQuery({
            page: currentPage,
            limit: resultPerPage,
            ...filters,
        });

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
        setCurrentPage(1);
    };

    const clearFilters = () => {
        setFilters((prev) => ({
            status: "", // For example: "Assigned", "Not Assigned"
            from: "",
            to: "",
        }));
    };

    console.log("Data: ", data);

    const pageHandler = (p) => {
        setCurrentPage(p);
    };

    useEffect(() => {
        if (data) {
            setTransactions(data?.transactions);
        }
    }, [data]);

    return (
        <>
            <MotionDiv>
                {isError ? (
                    <MessageBox variant="danger">
                        {error?.data?.error?.message}
                    </MessageBox>
                ) : (
                    <>
                        {/* Filters Section */}
                        <Container>
                            <Row className="filters">
                                <Col md="3">
                                    <SelectInput
                                        label="Status"
                                        name="status"
                                        value={filters.status}
                                        options={[
                                            { Pending: "Pending" },
                                            { Completed: "Completed" },
                                            { Cancelled: "Cancelled" },
                                        ]}
                                        onChange={handleFilterChange}
                                    />
                                </Col>
                                <Col md="3">
                                    <DateInput
                                        label="From"
                                        name="from"
                                        value={filters.from}
                                        onChange={handleFilterChange}
                                    />
                                </Col>
                                <Col md="3">
                                    <DateInput
                                        label="To"
                                        name="to"
                                        value={filters.to}
                                        onChange={handleFilterChange}
                                    />
                                </Col>

                                <Col md="3">
                                    <Button onClick={clearFilters}>Clear Filters</Button>
                                </Col>
                            </Row>
                        </Container>
                        <CustomTable
                            loading={isFetching}
                            column={column}
                            rowNo={resultPerPage}
                            rowProps={{ setResultPerPage }}
                            paging={true}
                            pageProps={{
                                numOfPages: data?.totalPages,
                                curPage: currentPage,
                            }}
                            pageHandler={pageHandler}
                        >
                            {transactions.length &&
                                transactions.map((transaction, i) => (
                                    <tr key={transaction.id} className="odd">
                                        <td className="text-center">
                                            {(currentPage - 1) * resultPerPage + i + 1}
                                        </td>
                                        <td style={{ textTransform: "capitalize" }}>
                                            <a className="text" onClick={() => navigate(`/admin/jobs/view/${transaction.job.id}`)}>{transaction.job.id}</a>
                                        </td>
                                        <td className="text-center">
                                            <span
                                                className={`badge ${transaction.status === "Pending"
                                                    ? "bg-warning text-dark"
                                                    : transaction.status === "Completed"
                                                        ? "bg-success"
                                                        : transaction.tatus === "Cancelled"
                                                            ? "bg-danger"
                                                            : "bg-secondary"
                                                    }`}
                                            >
                                                {transaction.status}
                                            </span>
                                        </td>
                                        <td>
                                            <a className="text" onClick={() => navigate(`/admin/lenders/view/${transaction.user.id}`)}>{transaction?.user?.name}</a>
                                        </td>
                                        <td>
                                            ${transaction.amount}
                                        </td>
                                        <td className="">
                                            {transaction.status === "Completed" ? formatDateTime(transaction.updated_at) : "N/A"}
                                        </td>
                                        <td className="text-center">
                                            <ViewButton
                                                onClick={() => navigate(`/admin/transaction/view/${transaction.id}`)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                        </CustomTable>
                    </>
                )}
            </MotionDiv>
            <ToastContainer />
        </>
    );
};

export default TransactionManagement;
